import { render, staticRenderFns } from "./PatientProfileModal.vue?vue&type=template&id=9b79e124&"
import script from "./PatientProfileModal.vue?vue&type=script&lang=js&"
export * from "./PatientProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b79e124')) {
      api.createRecord('9b79e124', component.options)
    } else {
      api.reload('9b79e124', component.options)
    }
    module.hot.accept("./PatientProfileModal.vue?vue&type=template&id=9b79e124&", function () {
      api.rerender('9b79e124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PatientProfile/components/desktop/PatientProfileModal.vue"
export default component.exports